<template>
  <div id="introducao">
    <div class="conteudo-dicas" :class="{'hidden':isError}">
      <div class=" d-flex justify-content-center align-items-center" >
        <input type="file" ref="fileInput" id="file"  class="hidden" name="file"  @change="handleFileChange" />
        <button name="botao" ref="botao" class="btn btn-lg btn-primary" @click="openFileInput">Selecione um arquivo</button>
      </div>
      <div id="footer"></div>
    </div>

    <div class="page-error" :class="{'hidden':!isError}">
      <ErrorComponent
          :title="errorMensage.title"
          :subtitle="errorMensage.subtitle"
          :button-text="errorMensage.button"
          :callback="errorMensage.callback"
      ></ErrorComponent>
    </div>

  </div>
</template>
<script>
import ErrorComponent from "../shared/Error";
import UploadDocDigitalService from "../../services/UploadDocDigitalService";

export default {
  name: "DocDigital",
  components: { ErrorComponent },
  mounted() {
    this.errorMensage.subtitle = `Precisamos do acesso aos seus documentos e pastas para abrir a ${this.tipoDoc} digital`
    this.uploadDocService = new UploadDocDigitalService();
    this.$store.dispatch("setTitulo", "Confirmação de identidade");
    this.$store.dispatch("setLoadingStatus", false);
    this.openMOdal();
  },
  data: function () {
    return {
      isError:false,
      showAllow: false,
      selectedFile: false,
      uploadDocService: '',
      errorMensage : {
        title : 'Algo deu errado ao acessar seus documentos',
        subtitle : '',
        button : 'Permitir acesso',
        callback : this.acaoBtnTentarNovamente
      }
    };
  },
  computed: {
    tipoDoc(){
      return this.$store.getters.tipoDoc;
    }
  },
  methods: {
    openMOdal:function (){
      if(confirm("Permitir o App Vivo acessar seus documentos e pastas?")){
        this.openFileInput();
      }else{
        this.isError = true;
      }
    },
    acaoBtnTentarNovamente:function (){
      this.openMOdal();
    },
    openFileInput() {
      try {
        $(this.$refs.fileInput).trigger('click');
      }
      catch (e) {
        this.erroUpload();
      }
    },

    async handleFileChange(event) {
      try{
        this.$store.dispatch('setLoadingStatus',true);
        if(event.target.files.length === 0) {
          throw new Error('Nenhum Arquivo selecionado');
        }
        this.selectedFile = event.target.files[0];

        const validTypes = ['application/pdf'];
        if(!validTypes.includes(this.selectedFile.type)){
          throw new Error('Apenas arquivos PDF são aceitos');
        }

        let validaChave = await this.uploadDocService.validaChave();
        let buscarToken = await this.uploadDocService.buscarToken(validaChave.res.liveness_autentication,validaChave.res.liveness_license);
        let enviaDocumento = await this.uploadDocService.enviaDocumento(this.selectedFile,buscarToken,validaChave.res.liveness_license,validaChave.res.liveness_autentication, this.tipoDoc);

        if(enviaDocumento === false){
          throw new Error(`Falha ao validar ${this.tipoDoc}`);
        }

        const reader = new FileReader();
        reader.onloadend = () => {
          // Use a regex to remove data url part
          const base64String = reader.result
              .replace('data:', '')
              .replace(/^.+,/, '');
          // altera para o store para nao dar erro de tamanho
          this.$store.getters.dados.doc_digital_base = 'data:' + this.selectedFile['type'] + ';base64,' + base64String;
          this.$store.dispatch('setLoadingStatus',false);
          this.$router.push({name: 'Analise'});
        };
        reader.readAsDataURL(this.selectedFile);

      }catch (e){
        console.log(e);
        this.erroUpload(e.message);
      }
    },

    erroUpload: function (message){
      this.$store.dispatch('setLoadingStatus',false);
      this.selectedFile = null;
      this.$refs.fileInput.value = null;
      this.isError = true;
      this.errorMensage.title = `Algo deu errado ao anexar sua ${this.tipoDoc} digital`;
      this.errorMensage.subtitle = (message && message !== '') ? message : 'Não foi possível concluir o anexo. Você pode tentar de novo';
      this.errorMensage.button = 'Tentar de novo';
      this.errorMensage.callback = this.tentarDenovo;
    },

    tentarDenovo: function () {
      this.$router.push({ name: "DocSelecao" });
    }


  },
};
</script>

<style scoped>
.hidden{
  display: none !important;
}
</style>../../services/UploadDocDigitalService



// WEBPACK FOOTER //
// src/components/pages/DocDigital.vue